import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-212c886c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-search" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "list-sort flex-ter" }
const _hoisted_5 = { class: "flex-ter" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "sort-btn flex-col"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "choice-box"
}

import { ref, toRef, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { t } from '@/plugins/i18n'
import SelectIcon from './SelectIcon.vue'

interface S {
    label: string
    bothway: boolean
    name: string
}


export default /*#__PURE__*/_defineComponent({
  props: ['params', 'sortTypes', 'tabList'],
  setup(__props) {

const props = __props
const route = useRoute()
const router = useRouter()

const params = toRef(props, 'params')
const isChecked = ref(route.query?.canOrder === '1')
const plat: any = ref(route.query?.tab ? Number(route.query.tab) : 0) // 0 商品 1 店铺

watch(route, (v) => {
  plat.value = v.query?.tab ? Number(v.query.tab) : 0
})

const getList = (value: any) => {
  plat.value = value
  change({ tab: plat.value })
}
// 商品所属国家筛选
const changeGoodsCountry = (val: string) => {
  change({ country: val })
}

const sort = ({ name, bothway }: S, order: boolean | void) => {
  if (typeof order === 'boolean') {
    change({
      sortType: name,
      descendOrder: order
    })
  } else {
    if (name === params.value.sortType) {
      change({
        descendOrder: bothway ? !params.value.descendOrder : true
      })
    } else {
      change({
        sortType: name,
        descendOrder: true
      })
    }
  }
}

const change = (v: any) => {
  console.log(v)
  const query = {
    ...route.query,
    ...v
  }
  if (v.canOrder === '') {
    delete query.canOrder
  }
  isChecked.value = Number(v.canOrder) === 1
  router.replace({ ...route, query })
}

return (_ctx: any,_cache: any) => {
  const _component_sapn = _resolveComponent("sapn")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabList, (tab) => {
        return (_openBlock(), _createElementBlock("span", {
          class: _normalizeClass(['child-title', { active: tab.value === plat.value }]),
          key: tab.value,
          onClick: ($event: any) => (getList(tab.value))
        }, _toDisplayString(tab.label), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('排序')), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sortTypes, (v) => {
        return (_openBlock(), _createElementBlock("div", {
          key: v.label,
          class: "flex-ter"
        }, [
          (v.select)
            ? (_openBlock(), _createBlock(_component_el_select, {
                key: 0,
                size: "small",
                class: _normalizeClass(`select-no-border-special ${v?.selectClass ?? ''}`),
                "model-value": _unref(params).country,
                "suffix-icon": SelectIcon,
                "popper-class": "select-no-border-special-popper",
                onChange: changeGoodsCountry,
                style: {"width":"150px","margin-left":"30px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.selectOption, (country) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      size: "sime",
                      key: country.value,
                      label: country.label + (v.fixLabel ?? ''),
                      value: country.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_sapn, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(country.label), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["label", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["class", "model-value"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["btn label", { active: _unref(params).sortType === v.name }]),
                  onClick: ($event: any) => (sort(v))
                }, _toDisplayString(v.label), 11, _hoisted_6),
                (v.bothway)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa fa-caret-up btn", {
                                active: _unref(params).sortType === v.name && !_unref(params).descendOrder
                            }]),
                        onClick: ($event: any) => (sort(v, false))
                      }, null, 10, _hoisted_8),
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa fa-caret-down btn", { active: _unref(params).sortType === v.name && _unref(params).descendOrder }]),
                        onClick: ($event: any) => (sort(v, true))
                      }, null, 10, _hoisted_9)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ]))
      }), 128)),
      (plat.value === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_el_checkbox, {
              onChange: _cache[0] || (_cache[0] = e => change({canOrder: e ? 1 : ''})),
              "model-value": isChecked.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('当前可购买')), 1)
              ]),
              _: 1
            }, 8, ["model-value"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})